const deleteVehicleUseCase = (repository) => async (id) => {
    return await repository(id);
}

export default deleteVehicleUseCase;